























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.ChannelTypeDto = new proxy.ChannelTypeDto();
    channelTypes = [];
    merchants = [];
    params: proxy.EditMerchantRateDto = new proxy.EditMerchantRateDto();

    get prox() {
        return new proxy.ChannelTypeServiceProxy();
    }
    syncrate() {
        this.merchants.map(x => {
            x.rate = this.model.rate;
        })
        this.$forceUpdate();
    }
    save() {
        if (!this.params.channelTypeId) {
            this.$Notice.error({ title: '请选择产品！' })
            return;
        }
        if (!this.params.merchantRate) {
            this.$Notice.error({ title: '请填写商户费率！' })
            return;
        }
        // if (typeof this.params.merchantRate !== 'number') {
        //     this.$Notice.error({ title: '请输入正确的商户费率' })
        //     return;
        // }
        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.prox.editMerchantRate(this.params).then();
                (this.$refs.roleForm as any).resetFields();
                this.$Notice.success({ title: "保存成功" });
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.params.channelTypeId = undefined;
            this.params.merchantRate = undefined
            this.params.merchantId = 0;
            let req2 = new proxy.MerchantSimpleInputDto();
            new proxy.MerchantServiceProxy().queryAllList(req2).then((x) => {
                this.merchants = x;
                let req = new proxy.ChannelTypePageInputDto();
                req.maxResultCount = 999;
                req.skipCount = 0;
                this.prox.queryModelList(req).then(t => {
                    this.channelTypes = t.items
                })
            });
        }
    }

    roleRule = {
        suppName: [
            {
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
    };
}
